module.exports = __webpack_public_path__ + "static/media/results-home-treatment.bc08cbd2.svg";